import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Orders from "./orders";
import Exact from "./exact";
import PurchaseOrders from "../purchase-orders/purchase-orders";
import PurchaseOrderDetail from "../purchase-orders/detail";

const PARENT_URL = "/cms/orders";

const Bestellingen = () => {
  return (
    <Routes>
      <Route path={`/all`} element={<Orders />} />
      <Route path={`/exact`} element={<Exact />} />
      <Route path={`/purchase-orders`} element={<PurchaseOrders />} />
      <Route path={`/purchase-orders/:id`} element={<PurchaseOrderDetail />} />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/all`} replace />} />
    </Routes>
  );
};

export default Bestellingen;
